<template>
    <div class="min-h-screen bg-gray-50/50">
        <div class="mx-auto max-w-7xl space-y-5 px-4 py-8 sm:px-6 lg:px-8">
            <ActivityHeader :date="date" />

            <DaySummaryBar :summary="summary" />

            <KpiGroups :summary="summary" />

            <ChartPanel :trend-data="trendData" :date="date" />

            <RecentEventsList
                :new-users="newUsers"
                :verified-users="verifiedUsers"
                :new-teams="newTeams"
                :new-free-plans="newFreePlans"
                :free-plan-restarts="freePlanRestarts"
                :new-subscriptions="newSubscriptions"
                :ending-trials="endingTrials"
                :yearly-subscriptions="yearlySubscriptions"
            />

            <DetailTabs
                :summary="summary"
                :new-users="newUsers"
                :verified-users="verifiedUsers"
                :new-teams="newTeams"
                :new-free-plans="newFreePlans"
                :free-plan-restarts="freePlanRestarts"
                :new-subscriptions="newSubscriptions"
                :team-updates="teamUpdates"
                :ending-trials="endingTrials"
                :yearly-subscriptions="yearlySubscriptions"
                :activity-logs="activityLogs"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import ActivityHeader from "./components/ActivityHeader.vue";
import DaySummaryBar from "./components/DaySummaryBar.vue";
import KpiGroups from "./components/KpiGroups.vue";
import ChartPanel from "./components/ChartPanel.vue";
import RecentEventsList from "./components/RecentEventsList.vue";
import DetailTabs from "./components/DetailTabs.vue";
import type { IDailyActivityProps } from "./types";

defineProps<IDailyActivityProps>();
</script>
